import React, { useContext, useEffect, useState } from 'react';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import FireDataContext from '../../../services/firebase/FireDataContext';

const InvoiceEditor = ({ path }) => {
    const db = useContext(FireDataContext);

    const [invoiceState, setInvoiceState] = useState({});
    const [jsonState, setJsonState] = useState('');

    useEffect(() => {
        db.get({ path }).then(doc => {
            if (!doc.timesheet.invoicee) {
                doc.timesheet.invoicee = {
                    name: ``,
                    address: [``, ``],
                    email: ``,
                    xeroContactId: '',
                }
            }
            setInvoiceState(doc);
        }
        ).catch(error => console.log(error));

    }, [db, path]);

    const handleApplyClick = value => {
        const updated = JSON.parse(jsonState);
        console.log(updated);
        setInvoiceState(updated);
    }

    return (
        <div>
            <TextField
                value={JSON.stringify(invoiceState, undefined, 4)}
                onChange={({ target: { value } }) => setJsonState(value)}
                fullWidth
                multiline
                style={{ marginBottom: '1rem', marginTop: '1rem' }}
            />
            <Button variant='contained' color='secondary' onClick={handleApplyClick} >
                Apply Changes
            </Button>
        </div>
    );
};

export default InvoiceEditor;